import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új kódtár',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            }
        ],
        searchFields: [
            {
                name: "text",
                label: "Név",
                formType: "text",
                formSize: 3
            },
            {
                name: "csId",
                label: "Típus",
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getOccupationHealthCodeStoreTypes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: true,
                formVisible: false
            },
            {
                name: "text",
                label: "Név",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                formRequired: true,
                formType: "text",
                formSize: 2,
                formVisible: true
            },
            {
                name: "description",
                label: "Leírás",
                visibility: true,
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "eesztId",
                label: "EESZT ID",
                visibility: true,
                formType: "text",
                formSize: 2,
                formVisible: true
            },
            {
                name: "csId",
                label: "Típus",
                filter: {
                    type: "simple",
                },
                formRequired: true,
                visibility: true,
                formType: "select",
                formSize: 3,
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getOccupationHealthCodeStoreTypes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "createdBy",
                label: "createdBy",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
